import Vue from 'vue'
import VueRouter from 'vue-router'

import PackagePage from '../components/package/package.vue'
import LoginPage from '../components/auth/login.vue'
import WebResponsePage from '../components/gatewayResponse/gatewayResponse.vue'
import TestVue from '../components/template_test.vue'
import error404 from '../components/404.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', component: PackagePage },
  { path: '/login',
    component: LoginPage,
    beforeEnter(to, from, next) {
      if (localStorage.getItem('token')) {
        next('/')
      } else {
        next()
      }
    }
  },
  { path: '/response', component: WebResponsePage },
  { path: '/playground', component: TestVue }, // playground
  { path: '/*', component: error404 }
]

export default new VueRouter({ routes })
